import * as actionTypes from "./actions";

const initialState = {
  isLoading: false,
  address: "",
  showMetaMaskButton: true,
  showFundOption: false,
  hasError: false,
  message: "",
  faucet: "",
  accounts: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ISLOADING:
      return {
        ...state,
        isLoading: action.value,
      };
    case actionTypes.SET_ADDRESS:
      return {
        ...state,
        address: action.value,
      };
    case actionTypes.SET_SHOWMETAMASKBUTTON:
      return {
        ...state,
        showMetaMaskButton: action.value,
      };
    case actionTypes.SET_SHOWFUNDOPTION:
      return {
        ...state,
        showFundOption: action.value,
      };
    case actionTypes.SET_HASERROR:
      return {
        ...state,
        hasError: action.value,
      };
    case actionTypes.SET_MESSAGE:
      return {
        ...state,
        message: action.value,
      };
    case actionTypes.SET_FAUCET:
      return {
        ...state,
        faucet: action.value,
      };
    case actionTypes.SET_ACCOUNTS:
      return {
        ...state,
        accounts: action.value,
      };
    default:
  }

  return state;
};

export default reducer;
